<template>
	<section class="body">
		<main class="container mt-6 py-12">
			<div class="row">
				<div class="col text-center">
					<img src="/assets/images/hellers24.svg" class="logo mb-20"/>

					<h1 class="mb-20">Check-In. 24 Hours. Be King.</h1>

					<div class="btn-wrap mb-12">
						<a @click.prevent="checkin" href="checkin.html" class="btn btn-primary btn-gold w-100">{{ $t('checkin.selectType.checkin')}}</a>
					</div>

					<div class="btn-wrap mb-12">
						<a @click.prevent="booking" href="checkin.html" class="btn btn-primary btn-gray w-100">{{ $t('checkin.selectType.booking')}}</a>
					</div>

					<div class="btn-wrap mb-12" v-show="false">
						<a @click.prevent="cancel" href="checkin.html" class="btn btn-primary btn-gray w-100">{{ $t('checkin.cancel')}}</a>
					</div>
				</div>
			</div>
		</main>
	</section>
</template>

<script>
    export default {
        props: [],
        data: function () {
            return {
            }
        },
        methods: {

            cancel() {
                this.$parent.guest = null;
                this.$parent.component = 'CheckinStart';
            },

            checkin() {
                this.$parent.component = 'CheckinLogin';
            },
            booking() {
              //        alert("Funktion noch nicht verfügbar/Function not available at the moment");
              // console.log("Funktion noch nicht verfügbar/Function not available at the moment");
            }
        },
        components: {}
    }
</script>

<style scoped lang="scss">

</style>
